export const InArticleSlots = ["3571560911", "2466702118"]
export const DisplayAdsSlots = ["9980292252", "7777511189"] // update in future
export const DisplayAdsSlotsSideNav = ["7777511189"]
